import { c as _c } from "react/compiler-runtime";
export default function RepCategorySearchItem(t0) {
  const $ = _c(20);
  const {
    category,
    selected,
    disabledCategories: t1,
    onSelect
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const disabledCategories = t2;
  const isSelected = selected === category;
  let t3;
  if ($[2] !== category || $[3] !== disabledCategories) {
    t3 = disabledCategories.includes(category);
    $[2] = category;
    $[3] = disabledCategories;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const isDisabled = t3;
  const t4 = `${isDisabled ? "tw-text-gray-500 tw-cursor-not-allowed" : "hover:tw-bg-iron-700 tw-text-white"} tw-py-2 tw-w-full tw-h-full tw-bg-transparent tw-border-none tw-text-left tw-flex tw-items-center tw-justify-between  tw-rounded-lg tw-relative tw-select-none tw-px-2  focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-primary-400 tw-transition tw-duration-300 tw-ease-out`;
  let t5;
  if ($[5] !== category || $[6] !== onSelect) {
    t5 = () => onSelect(category);
    $[5] = category;
    $[6] = onSelect;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== category) {
    t6 = <span className="tw-text-sm tw-font-medium ">{category}</span>;
    $[8] = category;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== isSelected) {
    t7 = isSelected && <svg className="tw-h-5 tw-w-5 tw-ml-2 tw-text-primary-300 tw-transition tw-duration-300 tw-ease-out" viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><path d="M20 6L9 17L4 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>;
    $[10] = isSelected;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t6 || $[13] !== t7) {
    t8 = <div className="tw-w-full tw-truncate">{t6}{t7}</div>;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== isDisabled || $[16] !== t4 || $[17] !== t5 || $[18] !== t8) {
    t9 = <li className="tw-h-full"><button type="button" disabled={isDisabled} className={t4} onClick={t5}>{t8}</button></li>;
    $[15] = isDisabled;
    $[16] = t4;
    $[17] = t5;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  return t9;
}